import { render, staticRenderFns } from "./PlayerComments.vue?vue&type=template&id=85231286"
import script from "./PlayerComments.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayerComments.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports